// extracted by mini-css-extract-plugin
export default {"root":"Ohf5DY7wElQdWMiWap1u","placeHolderShimmer":"OI7TpyvKpt6QmMDrgBzn"};